import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press2',
  templateUrl: './notice-press2.component.html',
  styleUrls: ['./notice-press2.component.scss']
})
export class NoticePress2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
